import { StyleSheet, View } from 'react-native';
import { ShimmerSkeleton } from '../../../components/animations/Skeleton';
import { HStack, VStack } from '../../../components/primitives';
import { useTranslation } from '../../../contexts/TranslationContext';
import { colors } from '../../../theme/colors';
import { tokens } from '../../../theme/tokens';

function CallCardSkeleton() {
  return (
    <View style={styles.card}>
      <HStack spacing="md" align="center">
        <ShimmerSkeleton width={42} height={42} borderRadius={14} />
        <VStack spacing="xs" style={styles.body}>
          <ShimmerSkeleton width="52%" height={15} borderRadius={4} />
          <ShimmerSkeleton width="34%" height={11} borderRadius={4} />
        </VStack>
        <ShimmerSkeleton width={66} height={20} borderRadius={tokens.radius.full} />
      </HStack>
      <HStack spacing="sm" style={styles.footer}>
        <ShimmerSkeleton width={82} height={18} borderRadius={tokens.radius.full} />
        <ShimmerSkeleton width={72} height={11} borderRadius={4} />
      </HStack>
    </View>
  );
}

export function CallListSkeleton({ count = 4 }: Readonly<{ count?: number }>) {
  const { t } = useTranslation();
  return (
    <VStack
      testID="calls-list-skeleton"
      spacing="sm"
      accessible
      accessibilityRole="progressbar"
      accessibilityLabel={t('voiceAgents.callsList.loadingSkeleton')}
    >
      {Array.from({ length: count }).map((_, index) => (
        <CallCardSkeleton key={`call-skeleton-${String(index)}`} />
      ))}
    </VStack>
  );
}

const styles = StyleSheet.create({
  card: {
    gap: tokens.spacing.md,
    padding: tokens.spacing.md,
    backgroundColor: colors.surface.row,
    borderWidth: 1,
    borderColor: colors.border.muted,
    borderRadius: tokens.radius.lg,
  },
  body: {
    flex: 1,
    minWidth: 0,
  },
  footer: {
    alignItems: 'center',
  },
});
